import type {ReactElement} from 'react';
import React from 'react';
import {Thumbnail} from '@Components/thumbnail';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {ClickableDiv} from '@Components/clickable-div';
import styles from './image-thumbnail-container.module.scss';
import {CircularProgressLoader} from '@Components/circular-progress-loader';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';

interface ImageThumbnailContainerProps {
  id?: string;
  className?: string;
  thumbnailClass?: string;
  imgSrc: string;

  onEdit(): void;
  isLoading?: boolean;
}

export function ImageThumbnailContainer({id = '', className = '', isLoading = false, thumbnailClass = '', ...props}: ImageThumbnailContainerProps): ReactElement {
  const getThumbnail = (): ReactElement => {
    if (isLoading) {
      return <CircularProgressLoader key={'thumb_loading'} classes={`radius-2`} />;
    }

    return (
      <Thumbnail
        className={`${styles.thumbnail} ${thumbnailClass} radius-2`}
        data={{
          type: ThumbnailType.IMAGE,
          imageSrc: props.imgSrc,
        }}
      />
    );
  };

  return (
    <ClickableDiv
      onClick={(): void => {
        props.onEdit();
      }}
      id={id}
      className={`${className} ${styles.container} flex-h-row border-s-darker flex-items-center radius-8`}
    >
      {getThumbnail()}
      <Icon icon="icon-pencil" className="spacing-p-l-2 spacing-p-r-2" size={IconSize.SIZE_ICON_16} />
    </ClickableDiv>
  );
}
